import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createDocumentGroup,
  deleteDocumentGroup,
  getDocumentGroup,
  getDocumentGroups,
  getDocumentGroupsMasterData,
  updateDocumentGroup
} from '../../../api/document-groups';
import { Discipline } from '../Discipline/disciplineSlice';

export const getDocumentGroupsAsync = createAsyncThunk(
  'documentGroups/getDocumentGroups',
  getDocumentGroups
);

export const getDocumentGroupsMasterDataAsync = createAsyncThunk(
  'documentGroups/getDocumentGroupsMasterData',
  getDocumentGroupsMasterData
);

export const getDocumentGroupAsync = createAsyncThunk(
  'documentGroups/getDocumentGroup',
  getDocumentGroup
);

export const createDocumentGroupAsync = createAsyncThunk(
  'documentGroups/createDocumentGroup',
  createDocumentGroup
);

export const updateDocumentGroupAsync = createAsyncThunk(
  'documentGroups/updateDocumentGroup',
  updateDocumentGroup
);

export const deleteDocumentGroupAsync = createAsyncThunk(
  'documentGroups/deleteDocumentGroup',
  deleteDocumentGroup
);

export interface DocumentGroup {
  id: number;
  name: string;
  order: number;
  disciplineId: number;
  discipline: Discipline;
}

interface DocumentGroupState {
  data: DocumentGroup[];
  masterData: DocumentGroup[];
  count: number;
  selectedDocumentGroup: DocumentGroup | null;
}

const initialState: DocumentGroupState = {
  data: [],
  masterData: [],
  count: 0,
  selectedDocumentGroup: null
};

export default createSlice({
  name: 'documentGroups',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDocumentGroupsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(
      getDocumentGroupsMasterDataAsync.fulfilled,
      (state, action) => {
        state.masterData = action.payload.data;
        state.count = action.payload.count;
      }
    );
    builder.addCase(getDocumentGroupAsync.fulfilled, (state, action) => {
      state.selectedDocumentGroup = action.payload;
    });
  }
});
